import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import media from '../../utils/style'
import { rem, lighten } from 'polished'
import { bool, string } from 'prop-types'
import OutboundLink from '../OutboundLink'

class LinkRounded extends React.PureComponent {
  render() {
    const LinkComp = this.props.to
      ? ({ eventCategory, ...rest }) => <Link {...rest} />
      : this.props.type
      ? 'Button'
      : ({ children, ...rest }) => (
          <OutboundLink {...rest}>{children}</OutboundLink>
        )
    const StyledLink = styled(
      ({
        to,
        href,
        onClick,
        className,
        children,
        eventCategory,
        shadow,
        outline,
        offer,
        dark,
        thin,
        stretched,
        ...rest
      }) => (
        <LinkComp
          className={className}
          to={to}
          href={href}
          onClick={onClick}
          eventCategory={eventCategory}
          {...rest}
        >
          {children}
        </LinkComp>
      )
    )`
      position: relative;
      display: inline-block;
      cursor: pointer;
      color: ${(props) =>
        props.reversed ? props.theme.colors.blue : props.theme.colors.white};
      text-decoration: none;
      text-transform: uppercase;
      background-color: ${(props) =>
        props.offer ? props.theme.colors.orange : props.theme.colors.blue};
      ${(props) => (props.reversed ? 'background-color: white;' : '')};
      ${(props) =>
        props.dark ? `background-color: ${props.theme.colors.grey};` : ''};
      transition: background-color 0.4s
          ${(props) => props.theme.ease.ease_out_circ},
        transform 0.4s ${(props) => props.theme.ease.ease_out_circ};
      padding: ${(props) => (props.thin ? rem(10) : rem(14))} ${rem(53)};
      margin-right: 3.5%;
      width: ${(props) => (props.stretched ? '80%' : 'initial')};
      border: ${(props) => (props.outline ? '2px white solid' : '0')};
      border-radius: ${rem(35)};
      font-size: ${rem(13)};
      font-weight: ${(props) => props.theme.weights[1]};
      line-height: 1.8;
      path {
        transition: fill 0.4s ${(props) => props.theme.ease.ease_out_circ};
      }
      &:hover {
        color: ${(props) =>
          props.outline ? props.theme.colors.blue : props.theme.colors.white};
        ${(props) => (props.dark ? `color: ${props.theme.colors.blue};` : '')};
        background-color: ${(props) =>
          lighten(
            0.12,
            props.offer ? props.theme.colors.orange : props.theme.colors.blue
          )};
        ${(props) =>
          props.dark ? `background-color: ${props.theme.colors.white};` : ''};
        ${(props) =>
          props.outline ? 'background-color:rgba(255, 255, 255, 1);' : ''};
        path {
          fill: ${(props) => props.theme.colors.white};
        }
      }
      &:only-child {
        margin-right: 0;
      }
      &[disabled] {
        color: ${(props) => props.theme.colors.grey_light_op65};
        border: 2px solid;
        cursor: default;
        pointer-events: none;
        background: white;
        opacity: 0.5;
        &::before {
          display: none;
        }
      }

      ${media.LargeScreenUp`
        overflow: visible;
        &::before {
          content:'';
          z-index: -1;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%) translateY(-30%);
          width: 85%;
          height: 100%;
          opacity: 0.7;
          box-shadow:  ${(props) =>
            props.shadow && !props.outline
              ? '0 25px 20px 0px rgba(66,76,94,0.35), 0 20px 15px 0 rgba(0,0,0,0.045)'
              : 'initial'};
          transition: transform 0.5s ${(props) =>
            props.theme.ease.ease_out_expo}, opacity 0.5s ${(props) =>
        props.theme.ease.ease_out_expo};
        }

        &:hover::before {
          opacity: 1;
          transform: translateX(-50%) translateY(-15%) scale(1.065, 0.65);
        }
      `};
    `
    return (
      <StyledLink
        {...this.props}
        className={['link'].concat(this.props.className || []).join(' ')}
        to={this.props.to}
      >
        {this.props.children}
      </StyledLink>
    )
  }
}

LinkRounded.defaultProps = {
  offer: false,
  shadow: false,
  stretched: false,
  outline: false,
  thin: false,
  reversed: false,
  dark: false
}
LinkRounded.propTypes = {
  offer: bool,
  shadow: bool,
  stretched: bool,
  outline: bool,
  thin: bool,
  reversed: bool,
  dark: bool,
  to: string,
  href: string
}

export default LinkRounded
